"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.servicingTransferDataType = exports.servicingTransactionType = exports.servicingProfileType = exports.servicingEscrowWithdraw = exports.servicingEscrowTaxes = exports.servicingEscrowSummary = exports.servicingEscrowInterest = exports.servicingEscrowInsurance = exports.servicingDocumentType = exports.servicingAllocationType = exports.servicingAchAccountType = exports.loanStatusType = exports.loanStatusDrawEligibilityType = exports.drawPaymentType = exports.drawEligibilityType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var servicingAchAccountType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  autopayEnabled: _propTypes.default.bool,
  accountType: _propTypes.default.string,
  accountHolderName: _propTypes.default.string,
  accountNumber: _propTypes.default.string,
  routingNumber: _propTypes.default.string
});

exports.servicingAchAccountType = servicingAchAccountType;

var servicingTransactionType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  amount: _propTypes.default.number,
  postDate: _propTypes.default.string,
  effectiveDate: _propTypes.default.string,
  type: _propTypes.default.string,
  typeDescription: _propTypes.default.string,
  message: _propTypes.default.string
});

exports.servicingTransactionType = servicingTransactionType;

var servicingProfileType = _propTypes.default.shape({
  autopayEnabled: _propTypes.default.bool,
  autopayAmount: _propTypes.default.number,
  autopayAccountUuid: _propTypes.default.string,
  disbursementAccountUuid: _propTypes.default.string
});

exports.servicingProfileType = servicingProfileType;

var servicingTransferDataType = _propTypes.default.shape({
  servicer: _propTypes.default.string,
  servicerName: _propTypes.default.string,
  displayName: _propTypes.default.string,
  daysSinceTransfer: _propTypes.default.number,
  transferTime: _propTypes.default.string,
  phone: _propTypes.default.string,
  url: _propTypes.default.string
});

exports.servicingTransferDataType = servicingTransferDataType;

var servicingAllocationType = _propTypes.default.shape({
  legacyType: _propTypes.default.string,
  owed: _propTypes.default.number,
  paid: _propTypes.default.number,
  type: _propTypes.default.string
});

exports.servicingAllocationType = servicingAllocationType;

var servicingEscrowWithdraw = _propTypes.default.shape({
  assetId: _propTypes.default.string,
  frequency: _propTypes.default.string,
  lastWithdrawDate: _propTypes.default.string,
  nextWithdrawDate: _propTypes.default.string,
  amount: _propTypes.default.number
});

exports.servicingEscrowWithdraw = servicingEscrowWithdraw;

var servicingEscrowTaxes = _propTypes.default.shape({
  withdrawInfo: _propTypes.default.objectOf(servicingEscrowWithdraw),
  parcelId: _propTypes.default.string,
  payeeCounty: _propTypes.default.string,
  payeeAddress: _propTypes.default.string,
  payeePhoneNumber: _propTypes.default.string
});

exports.servicingEscrowTaxes = servicingEscrowTaxes;

var servicingEscrowInsurance = _propTypes.default.shape({
  coverageType: _propTypes.default.string,
  policyNumber: _propTypes.default.string,
  withdrawInfo: _propTypes.default.objectOf(servicingEscrowWithdraw),
  expirationDate: _propTypes.default.string,
  coverageAmount: _propTypes.default.number,
  insuranceCompany: _propTypes.default.string,
  payeePhoneNumber: _propTypes.default.string,
  payeeAddress: _propTypes.default.string
});

exports.servicingEscrowInsurance = servicingEscrowInsurance;

var servicingEscrowInterest = _propTypes.default.shape({
  escrowInterestProfileId: _propTypes.default.string,
  state: _propTypes.default.string,
  stateAbbreviation: _propTypes.default.string,
  calculationType: _propTypes.default.string,
  escrowInterestPayoutFrequency: _propTypes.default.string,
  escrowInterestBalanceCalculationType: _propTypes.default.string,
  effectiveRate: _propTypes.default.number,
  effectiveDate: _propTypes.default.string,
  expirationDate: _propTypes.default.string,
  payoutOnTransfer: _propTypes.default.bool,
  nextDisbursementDate: _propTypes.default.string,
  expirationReason: _propTypes.default.string,
  isActive: _propTypes.default.bool,
  stateId: _propTypes.default.number
});

exports.servicingEscrowInterest = servicingEscrowInterest;

var servicingEscrowSummary = _propTypes.default.shape({
  currentBalance: _propTypes.default.number,
  currentPayment: _propTypes.default.number,
  taxes: _propTypes.default.arrayOf(servicingEscrowTaxes),
  insurance: _propTypes.default.arrayOf(servicingEscrowInsurance),
  escrowDisabled: _propTypes.default.bool,
  escrowInterestProfile: _propTypes.default.objectOf(servicingEscrowInterest),
  nonEffectiveEscrowInterestProfiles: _propTypes.default.arrayOf(servicingEscrowInterest)
});

exports.servicingEscrowSummary = servicingEscrowSummary;

var loanStatusDrawEligibilityType = _propTypes.default.shape({
  activeDrawFreezeTermination: _propTypes.default.bool,
  additionalDrawLimit: _propTypes.default.number,
  assetId: _propTypes.default.string,
  borrowerId: _propTypes.default.string,
  borrowerWaivedEligibility: _propTypes.default.bool,
  creditLimit: _propTypes.default.number,
  cutoffDate: _propTypes.default.string,
  eligible: _propTypes.default.bool,
  hasDrawTerms: _propTypes.default.bool,
  inForbearance: _propTypes.default.bool,
  interestRate: _propTypes.default.number,
  isBelowMinDraw: _propTypes.default.bool,
  isDelinquent: _propTypes.default.bool,
  isPastDeadline: _propTypes.default.bool,
  marginInterest: _propTypes.default.number,
  maxDrawAmount: _propTypes.default.number,
  meetsConsecutivePaymentsAfterForbearance: _propTypes.default.bool,
  parentInterestRate: _propTypes.default.number,
  parentPrimeRate: _propTypes.default.number,
  paymentChangeDate: _propTypes.default.string,
  pendingDraw: _propTypes.default.bool,
  primeRate: _propTypes.default.number,
  profileChangeDate: _propTypes.default.string,
  projectEligible: _propTypes.default.bool,
  projectMaxAmount: _propTypes.default.number,
  remainingTermMonths: _propTypes.default.number
});

exports.loanStatusDrawEligibilityType = loanStatusDrawEligibilityType;

var loanStatusType = _propTypes.default.shape({
  borrowerId: _propTypes.default.string,
  nextDueDate: _propTypes.default.string,
  nextPaymentAmount: _propTypes.default.number,
  monthlyPaymentAmount: _propTypes.default.number,
  currentPrincipal: _propTypes.default.number,
  originalPrincipal: _propTypes.default.number,
  currentEscrow: _propTypes.default.number,
  currentFees: _propTypes.default.number,
  currentInterest: _propTypes.default.number,
  totalOwed: _propTypes.default.number,
  daysLate: _propTypes.default.number,
  isPaymentDue: _propTypes.default.bool,
  isPaymentAllowed: _propTypes.default.bool,
  interestRate: _propTypes.default.number,
  assetId: _propTypes.default.string,
  originalTermMonths: _propTypes.default.number,
  remainingTermMonths: _propTypes.default.number,
  rateType: _propTypes.default.string,
  loanType: _propTypes.default.string,
  loanNumber: _propTypes.default.string,
  nextAutopayAmount: _propTypes.default.number,
  nextAutopayDate: _propTypes.default.string,
  nextAutopayLocalDate: _propTypes.default.string,
  profile: _propTypes.default.objectOf(servicingProfileType),
  achAccounts: _propTypes.default.arrayOf(servicingAchAccountType),
  transactions: _propTypes.default.arrayOf(servicingTransactionType),
  status: _propTypes.default.string,
  transferred: _propTypes.default.bool,
  transferData: servicingTransferDataType,
  daysSinceTransfer: _propTypes.default.number,
  allocations: _propTypes.default.objectOf(servicingAllocationType),
  drawEligibility: loanStatusDrawEligibilityType,
  servicerName: _propTypes.default.string,
  escrowSummary: _propTypes.default.objectOf(servicingEscrowSummary),
  qualifiedPaymentsOnly: _propTypes.default.bool,
  uuid: _propTypes.default.string,
  amount: _propTypes.default.number,
  rate: _propTypes.default.number,
  term: _propTypes.default.number
});

exports.loanStatusType = loanStatusType;

var drawEligibilityType = _propTypes.default.shape({
  assetUuid: _propTypes.default.string,
  borrowerUuid: _propTypes.default.string,
  eligible: _propTypes.default.bool,
  cutoffDate: _propTypes.default.string,
  maxAmount: _propTypes.default.number,
  paymentChangeDate: _propTypes.default.string,
  currentMonthlyPayment: _propTypes.default.number,
  primeRate: _propTypes.default.number,
  parentPrimeRate: _propTypes.default.number,
  marginInterest: _propTypes.default.number,
  isPastDeadline: _propTypes.default.bool,
  isDelinquent: _propTypes.default.bool,
  isBelowMinDraw: _propTypes.default.bool,
  parentRate: _propTypes.default.number,
  drawRate: _propTypes.default.number,
  parentInterestAggregate: _propTypes.default.number,
  drawInterestAggregate: _propTypes.default.number
});

exports.drawEligibilityType = drawEligibilityType;

var drawPaymentType = _propTypes.default.shape({
  assetUuid: _propTypes.default.string,
  amount: _propTypes.default.number,
  totalMonthlyPayment: _propTypes.default.number
});

exports.drawPaymentType = drawPaymentType;

var servicingDocumentType = _propTypes.default.shape({
  assetUuid: _propTypes.default.string,
  borrowerUuid: _propTypes.default.string,
  createdDate: _propTypes.default.string,
  docDescription: _propTypes.default.string,
  docType: _propTypes.default.string,
  fidoUuid: _propTypes.default.string,
  fileName: _propTypes.default.string,
  tags: _propTypes.default.object
});

exports.servicingDocumentType = servicingDocumentType;